import { useEffect, useState } from "react";
import {
  readRateLimitState,
  clearRateLimitState,
  type StoredRateLimitState,
} from "../lib/rateLimitStorage";

interface UseRateLimitStateResult {
  rateLimitState: StoredRateLimitState | null;
  minutesUntilReset: number | null;
}

/** Reads the persisted rate limit state and auto-clears it when the window expires. */
export function useRateLimitState(): UseRateLimitStateResult {
  const [rateLimitState, setRateLimitState] = useState<StoredRateLimitState | null>(() =>
    readRateLimitState()
  );

  const minutesUntilReset = rateLimitState
    ? Math.max(1, Math.ceil((rateLimitState.reset - Math.floor(Date.now() / 1000)) / 60))
    : null;

  useEffect(() => {
    if (rateLimitState?.remaining !== 0) return;
    const secondsLeft = rateLimitState.reset - Math.floor(Date.now() / 1000);
    if (secondsLeft <= 0) {
      clearRateLimitState();
      setRateLimitState(null);
      return;
    }
    const timer = setTimeout(
      () => {
        clearRateLimitState();
        setRateLimitState(null);
      },
      secondsLeft * 1000 + 500
    );
    return () => clearTimeout(timer);
  }, [rateLimitState]);

  return { rateLimitState, minutesUntilReset };
}
